import { countRangeWiseInfo } from "./product-count-wise-bom-info";

export class DrilldownInfo {
    data: any[];
    id?: string;
    name?:string;
    label?:string;
    /**
     * 
     * @param data
     */
    constructor(data: any[],id?:string,name?:string,label?:string) {
        this.data = data;
        this.id = id;
        this.name = name;
        this.label = label;
    }
}